<template>
  <div class="page-share">
    <div class="share-content">
      <div @click="clickBack" class="share-close"></div>
      <img src="~@this/assets/share.jpg" alt="" class="share-image" />
      <div class="share-tips"></div>
    </div>
  </div>
</template>

<script>
import { Popup } from 'vant';

export default {
  methods: {
    clickBack() {
      this.$router.back();
    },
  },
  components: {
    [Popup.name]: Popup,
  },
};
</script>

<style lang="scss" scoped>
.page-share {
  min-width: 100vw;
  min-height: 100vh;
  background: #9e9999;
  .share-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    .share-close {
      background: url(~@this/assets/close.png) no-repeat;
      background-size: 100% 100%;
      width: 80px;
      height: 80px;
      margin-left: 75%;
      margin-bottom: 20px;
    }
    .share-image {
      width: 629px;
      margin-bottom: 20px;
    }
    .share-info {
      background: url(~@this/assets/share-tips.png) no-repeat;
      background-size: 100% 100%;
      width: 501px;
      height: 121px;
      margin: 15px 0 30px;
    }
  }
}
</style>
